// extracted by mini-css-extract-plugin
export default {"wrapper":"BundleHeader-wrapper-HHR","content":"BundleHeader-content-IoM","title":"BundleHeader-title-h1s","list":"BundleHeader-list-TY_","markdown":"BundleHeader-markdown-Spy"};